import React from 'react';
import Form from "../../../gd-form/form/form-ui5/form";
import FormRow from "../../../gd-form/form/form-ui5/form-row";
import UserIcon from "../../../gd-components/icons/user-icon";

export default class CustomViewAccessSharedWith extends React.Component {

    constructor(props) {
        super(props);
    }



    render() {

        const owner = gd.session.users.get(this.props.view.userId);

        return (

            <div className="ui5-plate modal-form">
                <Form size="size-30-70">

                    <div className="f-tbl">

                        <FormRow label="Owner" elementClass="txt-36">

                            <div className="fl-ac">
                                <UserIcon userId={this.props.view.userId} size="26" className="m-r-10" />
                                {owner.name}
                            </div>


                        </FormRow>

                        <FormRow label="Shared with">
                            {this.props.view.sharedUsers.map((userId)=>{

                                const user = gd.session.users.get(userId);

                                return (
                                    <div key={userId} className="fl-ac height-36">
                                        <UserIcon userId={userId} size="26" className="m-r-10" />
                                        {user.name}
                                    </div>
                                )
                            })}
                        </FormRow>

                    </div>

                </Form>
            </div>
        );
    }
}